import {createContext, useContext, useEffect, useState} from "react";
import {hasActiveSession} from "../services/authService";


let externalSetIsValid = null;

export const registerSetIsValid = (fn) => {
    externalSetIsValid = fn;
};

export const setIsValidOutsideReact = (value) => {
    if (externalSetIsValid) externalSetIsValid(value);
};


const AuthContext = createContext({
    valid: Boolean,
    isCheckingAuth: Boolean,
    userInfo: {}
});


export function AuthProvider({ children }) {
    const [valid, setValid] = useState(false)
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);
    const [userInfo, setUserInfo] = useState({})


    useEffect(() => {
        const abortController = new AbortController();
        
        const checkSession = async () => {
            try {
                const isUserActive = await hasActiveSession(abortController.signal);
                if (isUserActive && !abortController.signal.aborted) {
                    setValid(true);
                    setUserInfo(isUserActive)
                }
            } catch (e) {
                console.log(e);
            } finally {
                if (!abortController.signal.aborted) {
                    setIsCheckingAuth(false);
                }
            }
        };
        checkSession();
        
        return () => {
            abortController.abort();
        };
    }, []);

    useEffect(() => {
        registerSetIsValid(setValid);
    }, []);

    return (
        <AuthContext.Provider value={{ valid, isCheckingAuth, userInfo, setUserInfo, setValid }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext)